import { render } from "./RaisingTable.vue?vue&type=template&id=971eb59e&scoped=true"
import script from "./RaisingTable.vue?vue&type=script&lang=js"
export * from "./RaisingTable.vue?vue&type=script&lang=js"

import "./RaisingTable.vue?vue&type=style&index=0&id=971eb59e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971eb59e"]])

export default __exports__